document.addEventListener('DOMContentLoaded', () => {
  setOurStoryHeaderHeight();
});
window.addEventListener('load', () => {
  setOurStoryHeaderHeight();
});
window.addEventListener('resize', debounceOurStory(() => {
  setOurStoryHeaderHeight();
}, 100));
document.addEventListener('shopify:section:load', () => {
  setOurStoryHeaderHeight();
});
function setOurStoryHeaderHeight() {
  const header = document.querySelector('.custom-header.custom-header--fixed');
  if (!header) {
    document.documentElement.style.setProperty('--home-story-header-height', '0px');
    return;
  }
  const headerHeight = header.getBoundingClientRect().height;
  document.documentElement.style.setProperty('--home-story-header-height', `${headerHeight}px`);
}
function debounceOurStory(callback, delay) {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(callback, delay);
  };
}